import { Box, Stack, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import type { ReactNode } from "react";

type CashRegisterReportHeroProps = {
  overline?: string;
  title: string;
  chips?: ReactNode;
};

/** Cabeçalho em gradiente alinhado a Estatísticas de vendas / Comissões. */
export function CashRegisterReportHero({
  overline = "Fluxo de caixa",
  title,
  chips,
}: CashRegisterReportHeroProps) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        overflow: "hidden",
        borderRadius: 3,
        border: "1px solid",
        borderColor: alpha(theme.palette.primary.main, 0.22),
        background: `linear-gradient(135deg, ${alpha(
          theme.palette.primary.main,
          0.12
        )} 0%, ${alpha(theme.palette.primary.dark, 0.06)} 55%, ${alpha(
          theme.palette.background.paper,
          1
        )} 100%)`,
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        alignItems={{ xs: "stretch", md: "center" }}
        justifyContent="space-between"
        sx={{ p: { xs: 2.5, md: 3 } }}
      >
        <Stack spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.15),
                color: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PointOfSaleOutlinedIcon />
            </Box>
            <Box>
              <Typography
                variant="overline"
                color="text.secondary"
                sx={{ letterSpacing: 0.08 }}
              >
                {overline}
              </Typography>
              <Typography
                variant="h5"
                component="p"
                sx={{ fontWeight: 800, letterSpacing: "-0.03em" }}
              >
                {title}
              </Typography>
            </Box>
          </Stack>
          {chips ? (
            <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
              {chips}
            </Stack>
          ) : null}
        </Stack>
        <Box sx={{ alignSelf: "center", maxWidth: 200, width: "100%", opacity: 0.92 }} aria-hidden>
          <svg viewBox="0 0 200 120" width="100%" height="auto">
            <defs>
              <linearGradient id="crh-reg" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor={theme.palette.primary.light} stopOpacity="0.9" />
                <stop offset="100%" stopColor={theme.palette.primary.main} stopOpacity="0.85" />
              </linearGradient>
            </defs>
            <rect x="12" y="16" width="176" height="88" rx="12" fill="#f8fafc" stroke="rgba(15,23,42,0.08)" />
            <rect x="28" y="36" width="40" height="52" rx="6" fill="url(#crh-reg)" opacity={0.85} />
            <rect x="80" y="28" width="40" height="60" rx="6" fill="url(#crh-reg)" opacity={0.95} />
            <rect x="132" y="44" width="40" height="44" rx="6" fill="url(#crh-reg)" opacity={0.75} />
            <path
              d="M 36 92 L 164 92"
              stroke="rgba(15,23,42,0.12)"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </Box>
      </Stack>
    </Box>
  );
}
